/**
 * External Imports
 */
import styled from 'styled-components';

/**
 * Nexus Imports
 */
import { NeuButton } from '@neutron/react';

export const RoundCloseContainer = styled.div`
  align-items: center;
  min-height: 48px;
  position: relative;
`;

export const CloseBtnContainer = styled.div`
  position: absolute;
  left: 0;
`;

export const DateTimeSelectContainer = styled.div`
  position: relative;
  width: 267px;
`;

export const EmployeeDateTimeSelectContainer = styled.div`
  display: flex;
  width: 10em;
`;

export const FutureTimeErrorSpan = styled.span`
  color: #ce3637;
  font-size: 14px;
  font-weight: bold;
  margin-top: 4px;
  position: absolute;
  bottom: -1rem;
`;

export const StyledLabel = styled.div`
  color: #191919;
`;

export const StartNeuButtonContainer = styled.div`
  margin-top: 1rem;
`;

export const StartNeuButton = styled(NeuButton)`
  margin-left: 2rem !important;
`;
